// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import LoaderSkelton from '@tcp/core/src/components/common/molecules/LoaderSkelton';
import styles from './CouponSkeleton.style';
import { renderLabel } from '../../../../../../../utils/labels/labelUtilty';

const CouponSkeleton = ({ className, heading, couponList, checkoutLabels }) => {
  return (
    <div className={`${className}`}>
      <BodyCopy
        className="couponList__heading"
        fontWeight="semibold"
        component="h2"
        fontSize="fs16"
        fontFamily="secondary"
      >
        {`${heading} (${couponList?.size})`}
      </BodyCopy>

      <div className="couponList__iconContainer">
        <div className="couponList__helpIcon">?</div>
        <Anchor
          fontSizeVariation="medium"
          underline
          anchorVariation="primary"
          fontFamily="secondary"
        >
          {renderLabel(
            checkoutLabels?.bagPage?.lbl_couponlist_helpAppling,
            'lbl_couponlist_helpAppling'
          )}
        </Anchor>
      </div>

      <div>
        <LoaderSkelton className="skeletonStyle" />
      </div>
    </div>
  );
};

CouponSkeleton.propTypes = {
  className: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  couponList: PropTypes.string.isRequired,
  checkoutLabels: PropTypes.string.isRequired,
};

export default withStyles(CouponSkeleton, styles);
export { CouponSkeleton as CouponSkeletonVanilla };
